export default __webpack_public_path__ + "static/media/eye.3286bcf0.webp";